import { useI18n } from 'builder/hooks/useI18n'
import { useMediaQueries } from 'builder/hooks/useMediaQueries'
import { TRANSLATION } from '../../constants'
import { Header, Actions, Item, Variant } from '../../../types'

type Steps = Record<Variant, Array<Item | undefined>>

export const useGetConfig = (variant: Variant) => {
  const { i18n } = useI18n()
  const { isPhone } = useMediaQueries()
  const KEY = `${TRANSLATION}.onboarding.steps.template`

  const header = i18n.t(`${KEY}.${variant}.info`) as unknown as Header
  const actions = i18n.t(`${KEY}.${variant}.actions`) as unknown as Actions

  const steps: Steps = {
    b: [
      {
        icon: 'writing',
        header: i18n.t(`${KEY}.b.steps.1.header`),
      },
      {
        icon: 'template',
        header: i18n.t(`${KEY}.b.steps.2.header`),
      },
      !isPhone && {
        icon: 'word',
        header: i18n.t(`${KEY}.b.steps.3.header`),
      },
      !isPhone && {
        icon: 'customization',
        header: i18n.t(`${KEY}.b.steps.4.header`),
      },
    ].filter(item => item) as Item[],

    c: [
      {
        icon: 'word',
        header: i18n.t(`${KEY}.c.steps.1.header`),
        description: i18n.t(`${KEY}.c.steps.1.description`),
      },
      {
        icon: 'template',
        header: i18n.t(`${KEY}.c.steps.2.header`),
        description: i18n.t(`${KEY}.c.steps.2.description`),
      },
    ],
  }

  return {
    header,
    actions,
    steps: steps[variant],
  }
}
